import { render, staticRenderFns } from "./DocumentPreviewPage.vue?vue&type=template&id=3a48d6ad"
import script from "./DocumentPreviewPage.vue?vue&type=script&lang=ts"
export * from "./DocumentPreviewPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports